import { Skeleton } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetPortfolioCovenantsByCreditFacilityIdQuery } from '../requests/portfolioCovenants.gql.generated';
import { InfoAlertWithDescription } from 'packages/common-frontend/components/InfoAlertWithDescription';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { createPortfolioCovenantsChartConfig } from 'packages/portfolio/ui/covenants/CovenantsContainer';
import { PortfolioCovenantChartTemplate } from 'packages/portfolio/ui/covenants/PortfolioCovenantChartTemplate';
import { getAllUniqueCovenantKeys } from 'packages/portfolio/ui/shared/portfolioChartUtils';

export const PortfolioCovenantsContainerV2 = () => {
  const { creditFacilityId } = useCreditFacilityContext();
  const {
    loading: isPortfolioCovenantsLoading,
    data: allPortfolioCovenantsData,
  } = useGetPortfolioCovenantsByCreditFacilityIdQuery({
    variables: {
      creditFacilityId,
    },
  });

  if (isPortfolioCovenantsLoading || !allPortfolioCovenantsData) {
    return (
      <Skeleton height="600px" data-testid="credit-agreements-route-loading" />
    );
  }

  if (
    !allPortfolioCovenantsData.getPortfolioCovenantsByCreditFacilityId.length
  ) {
    return (
      <InfoAlertWithDescription description="No covenant calculations are available in the selected time period." />
    );
  }

  const uniquePortfolioCovenantKeys = getAllUniqueCovenantKeys(
    allPortfolioCovenantsData.getPortfolioCovenantsByCreditFacilityId,
  );

  return (
    <>
      {_.map(uniquePortfolioCovenantKeys, (portfolioCovenantKey) => {
        return (
          <PortfolioCovenantChartTemplate
            creditFacilityId={creditFacilityId}
            chartTitle={commonUtils.toTitleCase(portfolioCovenantKey)}
            covenantKey={portfolioCovenantKey}
            chartConfig={createPortfolioCovenantsChartConfig('percentage')}
            key={`portfolio-covenant-chart-${portfolioCovenantKey}`}
          />
        );
      })}
    </>
  );
};
